angular.module('harriApp')
  .controller('ClientPortalController',["$scope", "$rootScope", "$state", "$stateParams", "$filter", "$compile", "DispatcherServices", "hFormReference", "hUser", "TagAPI", "$q", "$timeout", "httpHelper", "clientPortalDetails", "hEvent", function ($scope,$rootScope,$state,$stateParams,$filter,$compile,DispatcherServices,hFormReference,hUser,TagAPI,$q,$timeout, httpHelper,clientPortalDetails, hEvent) {

    /* filter constants */

    $scope.FILTERS = {
      ALL_RESULTS : 'all',
      CLIENT_RESPONSE : 'both',
      CLIENT_PASS : 'pass',
      CLIENT_PROCEED : 'proceed'
    };


    //is Preview
    $scope.previewMode = !($state.current.name == 'client-portal');


    /* was candidates */
    $scope.thereIsCandidates = false;
    /* show indicator */
    $scope.previewModeIndicatorVis = $scope.previewMode;

    /* selected filter in client portal (with intial value equal to all, bring all data without filteration)*/
    $scope.selectedFilter = $scope.FILTERS.ALL_RESULTS;

    if(!clientPortalDetails || !clientPortalDetails.data || clientPortalDetails.data.status_code != 200 || !clientPortalDetails.data.data){
      hRedirect('/404');
      return;
    }

    if( hUser.isLoggedIn() ){
      hEvent.track(
        'client_portal_viewed',
        {  },
        function(){});
    }

    $scope.clientPortalDetails = clientPortalDetails.data.data;

    /* agency media */
    if($scope.clientPortalDetails.agency && $scope.clientPortalDetails.agency.length){
      if($scope.clientPortalDetails.agency[0].Brand.BrandMedia){
        var agencyBrandMedia = $scope.clientPortalDetails.agency[0].Brand.BrandMedia;
        $scope.clientPortalDetails.agency[0].Brand.backgroundMedia = findBrandMediaByType(agencyBrandMedia, 'background_image');
        $scope.clientPortalDetails.agency[0].Brand.profileMedia = findBrandMediaByType(agencyBrandMedia, 'profile_image');
      }
    }

    /* brand Media */
    if($scope.clientPortalDetails.brand && $scope.clientPortalDetails.brand.length){
      if($scope.clientPortalDetails.brand[0].Brand.BrandMedia){
        var brandBrandMedia = $scope.clientPortalDetails.brand[0].Brand.BrandMedia;
        $scope.clientPortalDetails.brand[0].Brand.backgroundMedia = findBrandMediaByType(brandBrandMedia, 'background_image');
        $scope.clientPortalDetails.brand[0].Brand.profileMedia = findBrandMediaByType(brandBrandMedia, 'profile_image');
      }
    }

    //Check if Agency
    $scope.isAgency = $scope.clientPortalDetails.isRecruiter;
    /* get Client ID from stateParams */
    $scope.clientId = $stateParams.client_id?$stateParams.client_id:hUser.data.user.id;
    /* client portal id to send for API viewing comments, this parameter is need when the client admin views candidates notes but not if it's agency */
    $scope.clientPortaIdNotes = '';
    if(!$scope.isAgency){
      $scope.clientPortaIdNotes = $scope.clientId;
    }
    /* define selected candidates array for bulk operations*/
    $scope.selectedCandidates = [];
    /* hold candidates */
    $scope.candidates = [];
    /* hold client portal admins */
    $scope.clientPortalAdmins = [];
    /* hold tags */
    $scope.candidatesTags = [];
    /* Pagination Params*/
    var LIMIT = 12;
    var lastTime='';
    var lastTimeOnlyIds = '';
    var initialSpeedyIds = [];
    //Valid Pagination
    $scope.loadMoreValid = true;

    /* Nunjucks Templates */
    var templateEng = DispatcherServices.getNunjucks();
    /* Templates Holder */
    var templates = {
      'candidate' : "../modules/client_portal/views/nunjucks-partial/candidate-card.tmpl.html",
      'position_row' : "../modules/client_portal/views/nunjucks-partial/position-row.tmpl.html"
    };

    /* holding some css selectors */
    var positionsListSelector = ".positions-list";
    var peopleSearchWrapperSelector = '.people-search-wrapper';

    /* This function will load Client Portal Data */
    $scope.loadData = function (){

      // This is to track performance on scrolling also (tracking started automatically on page load)
      PerformanceUtils.startTracking(null, true);

      var defer = $q.defer();

      /* still loading the data */
      $scope.loading = true;
      $timeout(function(){ $scope.$apply(); });

      /* Create Payload Request */
      var params = {};


      params.clientId = $scope.clientId;
      params.limit = LIMIT;
      params.offset = $scope.candidates.length;

      params.lastTime = ($scope.candidates.length>0 )?lastTime:'';
      params.selectedFilter = ($scope.selectedFilter == $scope.FILTERS.ALL_RESULTS)?'':$scope.selectedFilter;


      /* Get List of positions and candidates */
      ClientPortalAPI.getCandidates(params).then(function(result){

        var newCandidates = result.Candidates;
        var hits = result.hits;
        lastTime = result.lastTime;

        if(newCandidates.length>0){
          $scope.thereIsCandidates = true;
          /* check if there are results not fetched yet */
          if((newCandidates.length + $scope.candidates.length) == hits ){
            $scope.loadMoreValid = false;
          }

          /* render new data */
          $scope.renderData(newCandidates);

          /* not loading */
          $scope.loading = false;


          TagAPI.getCandidatesTags(hUser.getUserContext().brand_id, _.pluck(newCandidates, 'id'),false, $scope.clientId).then(function(res){
            /* map candidates and tags */
            if(res && res.data && res.data.data){
              var tags = res.data.data;
              for(var i in tags){
                if(!$scope.candidatesTags[tags[i].candidate_id]){
                  $scope.candidatesTags[tags[i].candidate_id] = tags[i];
                }
              }
              $timeout(function(){ $scope.$apply(); });
            }
          },function(res){
            console.log('an error with tags!');
          });

          defer.resolve();
        }else{
          /* when an empty candidate array is returned, block any next call */
          $scope.loadMoreValid = false;
          /* not loading */
          $scope.loading = false;
          $timeout(function(){ $scope.$apply(); });
          //reject
          defer.reject("candidates array empty!");
        }

      }, function(res){
        defer.reject(res);
      });

      return defer.promise;
    }


    /* Handle rendering process */
    $scope.renderData = function (newCandidates){
      // To be used to trigger time tracking when all candidates shown
      var numberOfCandidates = newCandidates && newCandidates.length;

      if (numberOfCandidates === 0) {
        PerformanceUtils.trackLoaded(hUser, $state);
      }

      var counter = 0;

      _.each(newCandidates, function(candidate){
        initialSpeedyIds.push({'id': candidate.ClientPortal.id  });
        $scope.candidates.push(candidate);

        /* render candidate HTML */
        var candidateHtml = $compile( templateEng.render( templates['candidate'], {member: candidate, isAgency: $scope.isAgency, selectedFilter: $scope.selectedFilter, previewMode: $scope.previewMode,FILTERS: $scope.FILTERS} ) )($scope);

        /* Check if candidate position is already in the list */
        var selector = positionsListSelector+" #position-"+candidate.ClientPortalPosition.id;
        if(!$(selector).length) {
          /* render position HTML if not already exist */
          var positionHtml = $compile(templateEng.render(templates['position_row'], {position: {name: candidate.ClientPortalPosition.name, id: candidate.ClientPortalPosition.id}}))($scope);
          /* append the new position */
          $(positionsListSelector).append(positionHtml);
        }

        /* append the new Candidefer*/
        _.defer(function() {
          /* append the new candidate */
          $(selector).find(peopleSearchWrapperSelector).append(candidateHtml);

          if (++counter === numberOfCandidates) {
            PerformanceUtils.trackLoaded(hUser, $state);
          }

        });



      });
    }

    /* pagination on scroll */
    $scope.doPagination = function() {

      /* check if still loading or no more candidates */
      if(!$scope.loadMoreValid || $scope.loading) return;

      /* trigger loading data action */
      $scope.loadData();
    };





    /*
    *
    * add to selected candidate array
    *
    */
    $scope.addCandidateToSelected = function (id){

          $scope.selectedCandidates.push(id);

    }

    /*
    *
    * Delete candidate from selected array
    *
    */
    $scope.deleteCandidateFromSelected = function (id){

        $scope.selectedCandidates =  remove_value($scope.selectedCandidates, id);

    }

    /*
    *
    * Delete candidate from client portal
    *
    */
    $scope.removeCandidatesFromPortal = function (){

      /* make sure the array is not empty */
      if(!$scope.selectedCandidates || $scope.selectedCandidates.length == 0){
        hAlert($filter("translate")("Error!"),$filter("translate")("You must select candidates to remove them!"));
        return;
      }

      $('#confirm-remove .modal').modal('show');

    }

    /*
    *
    *  Remove Selected Candidates action
    *
    */
    $scope.removeSelectedCandidatesAction = function(){

      $('#delete-selected-btn').button('loading');

      ClientPortalAPI.removeCandidates($scope.selectedCandidates,$scope.clientId).then(function (result){

        $('#confirm-remove .modal').modal('hide');
        $('#delete-selected-btn').button('reset');

        /* remove deleted candidates from client portal*/
        _.each($scope.selectedCandidates,function(clientPortalId) {
          var index =  $scope.findCandidateInArray($scope.candidates,clientPortalId);
          if(index != -1){
            $scope.removeCandidateFromScreen(clientPortalId,index);
          }
        });

        //re-initializing selected candidates
        $scope.selectedCandidates = [];

      },function(err){
        hAlert($filter("translate")("Error!"),result.data.data);
      });

    }

    /* Remove From Screen */
    $scope.removeCandidateFromScreen = function(clientPortalId,arrayIndex){

        $('.candidates').find('.member-widget-'+clientPortalId).parent().remove();
        /* check if position is empty or not */
        var positionId = $scope.candidates[arrayIndex].ClientPortalPosition.id;

        var positionSelector = ".position-section#position-"+positionId;
        if(!$(positionSelector).find('.people-search-wrapper>div').length){
          $(positionSelector).remove();
        }

        /* delete it from the array */
        ar_delete($scope.candidates,arrayIndex);
        $timeout(function(){ $scope.$apply(); });

    }

    /* Remove From Screen */
    $scope.toggleCandidateFromScreen = function(clientPortalId,arrayIndex, alwaysRemove){
        var $candRef = $('.candidates').find('.member-widget-'+clientPortalId).parent();
        if( alwaysRemove ){
          $candRef.addClass('hide');
        }
        else{
          $candRef.toggleClass('hide');
        }

        /* check if position is empty or not */
        var positionId = $scope.candidates[arrayIndex].ClientPortalPosition.id;

        var positionSelector = ".position-section#position-"+positionId;
        if($(positionSelector).find('.people-search-wrapper>div.hide').length == $(positionSelector).find('.people-search-wrapper>div').length){
          $(positionSelector).addClass('hide');
        }else{
          $(positionSelector).removeClass('hide');
        }


        if($('.positions-list').find('.people-search-wrapper>div.hide').length == $('.positions-list').find('.people-search-wrapper>div').length){
          $('.no-results').addClass('force-show');
        }else{
          $('.no-results').removeClass('force-show');
        }
        /* delete it from the array */
       // ar_delete($scope.candidates,arrayIndex);
        $timeout(function(){ $scope.$apply(); });

    }
    /* find candidate index in array from candidate portal id */
    $scope.findCandidateInArray = function(arr,ClientPortalId){
      var index = -1;
      if(!arr || !arr.length){
        return index;
      }

      for(var i in arr){
        if(arr[i].ClientPortal.id == ClientPortalId){
          index = i;
          break;
        }
      }

      return index;
    }
    /*
    *
    * show share with client modal
    *
     */
    $scope.showShareModal = function(){

      if(!$scope.candidates.length && !$scope.thereIsCandidates){
        hAlert($filter("translate")("Error!"),$filter("translate")("You must add candidates to the client portal first!"));

        return;
      }
      hFormReference.getForm('client_portal/share_via_email').then(function (form) {

          /* load data */
          var scope = form.scope;
          scope.reset();

          //reset some values
          scope.clientPortalAdmins = [];
          scope.selectedAdmins = [];
          /* get list of admins and add it to the form*/
          var promise = ClientPortalAPI.getClientPortalAdmins(scope.clientId);
          promise.then(function (res) {
            _.each(res, function(item){
                scope.clientPortalAdmins.push(item.ClientAdmin.email)
            });
            $timeout(function(){ scope.$apply(); });
          });

          /* show the form modal */
          $('#share-via-email-modal .modal').modal('show');

      });

    }

    var bufferedIds = [];


    /* watch like event recived from source (e.g speedyX screen) */
    $rootScope.$on('candidate.like', function(event,candidatePortalId,preLike,likeToSend) {

      /* find candidate index in array */
      var index =  $scope.findCandidateInArray($scope.candidates,candidatePortalId);

      if(index != -1){
        if($scope.selectedFilter == $scope.FILTERS.CLIENT_PASS || $scope.selectedFilter == $scope.FILTERS.CLIENT_PROCEED){

          if( ($scope.selectedFilter == $scope.FILTERS.CLIENT_PASS  && likeToSend == -1) || ( $scope.selectedFilter == $scope.FILTERS.CLIENT_PROCEED && likeToSend == 1) ){

              /* remove from screen */
              $scope.toggleCandidateFromScreen(candidatePortalId,index);
              var inBuffered = _.find(bufferedIds, function(ele){ return ele.id == candidatePortalId; });
              if(inBuffered){
                initialSpeedyIds.splice(inBuffered.id, 0, {id: inBuffered.id});
                ar_delete(bufferedIds,_.indexOf(bufferedIds, inBuffered) );
              }else{
                /* find and remove from SpeedyScreen array */
                var indexSpeedy = _.indexOf(initialSpeedyIds, _.findWhere(initialSpeedyIds, {'id':candidatePortalId}));
                bufferedIds.push({id: candidatePortalId, index: indexSpeedy});
                ar_delete(initialSpeedyIds,indexSpeedy);
              }

          }

          else{
              $scope.toggleCandidateFromScreen(candidatePortalId,index, true);
              var indexSpeedy = _.indexOf(initialSpeedyIds, _.findWhere(initialSpeedyIds, {'id':candidatePortalId}));
              bufferedIds.push({id: candidatePortalId, index: indexSpeedy});
              ar_delete(initialSpeedyIds,indexSpeedy);
          }


        }else{
          $scope.updateCandidateLikeModalValue(index,likeToSend);
        }
        /* update pass and proceed counts */
        $scope.updateActionBarCounts(preLike,likeToSend);
      }
    });


    /*
    /* Update Action Bar Counts
    *
    */
    $scope.updateActionBarCounts = function(preLike, nextLike){
      if(preLike == -1){
        $scope.clientPortalDetails.pass_count -=1;
      }else if(preLike == 1){
        $scope.clientPortalDetails.proceed_count -=1;
      }

      if(nextLike == -1){
        $scope.clientPortalDetails.pass_count +=1;
      }else if(nextLike == 1){
        $scope.clientPortalDetails.proceed_count +=1;
      }
    }

    /*
    *
    * Update Candidate Like Status
    * -1 dislike, 0 none, 1 like
    *
     */
    $scope.likeCandidate = function(candidatePortalId,likeStatus){

      /* return if in preview mode */
      if($scope.previewMode){
        return;
      }


      var index =  $scope.findCandidateInArray($scope.candidates,candidatePortalId);

      if(index != -1){

        var likeToSend = likeStatus;
        var preLike = $scope.candidates[index].ClientPortal.like;

        if(likeStatus == 1){
          likeToSend = ($scope.candidates[index].ClientPortal.like == 1)?0:1;
        }else{
          likeToSend = ($scope.candidates[index].ClientPortal.like == -1)?0:-1;
        }

        /* send to API */
        ClientPortalAPI.updateCandidateLikeStatus(candidatePortalId, likeToSend);

        /* update array value */
        $scope.updateCandidateLikeModalValue(index,likeToSend);

        /* update pass and proceed counts in action bar */
        $scope.updateActionBarCounts(preLike,likeToSend);

      }

    }

    $scope.updateCandidateLikeModalValue = function(index,likeToSend){
      /* update saved like */
      $scope.candidates[index].ClientPortal.like = likeToSend;
    }


    $scope.showSpeedyScreen = function($event, activeMemberId, activeClientId){


        if($scope.isAgency){
         // return;
        }
        $event.preventDefault();
        $scope.activeId  = 0;
        $('body').addClass('hide-overflow');
        $('#speedy-portal-modal').speedyX({
            'loadIds': function(loadedIds) {
              var defer = jQuery.Deferred();
                if (loadedIds == 0) {
                    // Start speedy screen with same ids as in search result
                    var initialIds = angular.copy(initialSpeedyIds);
                    defer.resolve(initialIds);
                }
                else {

                    var APIParams = {
                      clientId: $scope.clientId,
                      limit: LIMIT,
                      offset: loadedIds,
                      only_ids: 1
                    };

                    if(lastTimeOnlyIds){
                      APIParams.lastTime = lastTimeOnlyIds;
                    }

                    APIParams.selectedFilter = ($scope.selectedFilter == $scope.FILTERS.ALL_RESULTS)?'':$scope.selectedFilter;

                    ClientPortalAPI.getCandidatesIds(APIParams).then(function (res) {
                        var ids = [];
                        for (var i in res.Candidates) {
                            ids.push({id: res.Candidates[i]});
                        }

                        defer.resolve(ids);
                    });
                }

                return defer.promise();
            },
            'loadIdsData': function (ids) {

                var defersMap = {};
                var promises = [];

                ids.forEach(function(id){
                    var defer = $q.defer();
                    defersMap[id] = defer;
                    promises.push(defer.promise);
                });

                var dataReadyHandler = function(id, memberData) {
                    memberData.id = id;
                    defersMap[id].resolve([memberData]);
                };

                var loadDataForIds = function() {
                    ids.forEach(function(memberId) {
                        if (memberId != activeClientId) {
                            httpHelper.g('client_portal/profile/member/' + memberId).then(function(res) {
                                dataReadyHandler(memberId, res.data.data);
                            });
                        }
                    });
                }

                if (ids.indexOf(activeClientId) >= 0) {
                    httpHelper.g('client_portal/profile/member/' + activeClientId).then(function(res){
                        dataReadyHandler(activeClientId, res.data.data);
                        loadDataForIds();
                    });
                }
                else {
                    loadDataForIds();
                }

                return promises;
            },
            'range': 3,
            'template': '../modules/client_portal/views/nunjucks-partial/client_portal_card.tmpl.html',
            'allowPagination': true,
            'limitBulkLoading': true,
            'additionalData': {
            },
            'onHide': function ($element) {
                $element.find('.candidate-card-modal').each(function () {
                    var slideScope = $(this).scope();
                    if (slideScope && slideScope.speedySearchData) {
                        slideScope.$destroy();
                    }
                });


                $('#speedy-portal-modal').speedyX('destroy');

                $('body').removeClass('hide-overflow');
            },
            'onRendered': function (element, data) {
                var card_scope = $scope.$new();
                card_scope.card = data;
                card_scope.card.profileImageFullURL = $filter("hUserProfileImage")([card_scope.card.profile_image, card_scope.card.user_info.id],"_image_profile_full",true);
                $compile(element)(card_scope);
                card_scope.$apply();
                $timeout(function(){
                    card_scope.$apply();
                });
            },
            'afterChange': function (activeId, $element, $activeElement) {
                $scope.activeId = activeId;
            },
            'onScroll': function ($element, $activeElement) {
            },
            'containerClass':function(){


                return '';
            },
            'beforeRemoveSlide': function(index, $ele){
                var slideRef = $ele.find('>div').scope();
                if( slideRef ){
                    slideRef.$destroy();
                }
            },
            'edgeRightText': $filter('translate')('You have reached the end of your client portal!')
        });

        $('#speedy-portal-modal').speedyX('show', activeClientId, true);

    };


    /* Clear Candidiates from screen */
    $scope.clearScreen = function(){
      $scope.loading = true;
      $scope.loadMoreValid = true;
      $scope.candidates = [];
      $scope.selectedCandidates = [];

      $(positionsListSelector).empty();
    }


    /* Change Selected Filter */
    $scope.changeFilter = function(newFilter){

        if(newFilter == $scope.selectedFilter){
          return;
        }

        initialSpeedyIds = [];

        $scope.selectedFilter = newFilter;
        $scope.clearScreen();

        /* hide no results when switching class */
        $('.no-results').removeClass('force-show');
        $timeout(function(){ $scope.$apply(); });

        $scope.loadData();

    }


    /* get user tags */
    $scope.getCandidateTags = function(candidateId){
      return $scope.candidatesTags[candidateId];
    }

    /* call load data function */
    $scope.loadData();



  }]);



/* Share Client Portal
---------------------------------------------*/
app.directive('shareClientPortal', ["hFormReference", "$stateParams", "$timeout", function(hFormReference,$stateParams,$timeout) {
  return {
    link: function(scope, element) {

      scope.clientId = $stateParams.client_id?$stateParams.client_id:hUser.data.user.id;
      scope.selectedAdmins = [];
      scope.syncAdmins = function(ev,item){

          /* multiple events can be trigrred from the ng-click */
          if(ev.target.tagName != 'INPUT'){
              return false;
          }

          /* check if email is already there then delete it otherwise add it to the array */
          var indexOfEmailInArray = _.indexOf(scope.selectedAdmins, item);
          if(indexOfEmailInArray == -1){
              scope.selectedAdmins.push(item);
          }else{
              scope.selectedAdmins.splice(indexOfEmailInArray,1);
          }
      };

      hFormReference.current(element, {
        beforeSave: function(formData, valid) {

            /* hold all emails will be sent to API */
            var emails = [];

            /* addCommaSepratedEmails */
            if(formData.new_email){
              emails = _.union(emails,_.map(formData.new_email.split(','), function(email){ return $.trim(email)}));
            }

            /* add admins selected from the chekbox */
            emails = _.union(emails,scope.selectedAdmins);
            if(!emails.length){
              return false;
            }

            /* Delete not needed params from from data */
            delete(formData.new_email);

            /* Data that will be sent to server */
            formData.emails = emails;
            formData.brand_id = scope.clientId;


            return formData;
        },
        afterSave: function(data, formData, requestStatus) {
          if(data && data.status_code == 200) {
            $('#share-via-email-modal .modal').modal('hide');
            $('#share-via-email-successful').modal('show');
          }
        }

      });
    }
  }
}]);
